<template>
  <svg class='laptop' width='240' height='100'>
    <g class='laptop-device'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 100,5
          L 200,5 200,65 100,65 100,5
          M 200,5
          L 195,5 195,65 200,65
        '
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
            class='screen'
        d='
          M 105,10
          L 190,10 190,60 105,60, 105,10
        '
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 100,65
          L 70,90 170,90 200,65
          L 200,70 170,95 69,95 69,90
        '
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 105,70
          L 185,70 165,85 85,85 105,70
          M 115,70 L 95,85 M 125,70 L 105,85
          M 135,70 L 115,85 M 145,70 L 125,85
          M 155,70 L 135,85 M 165,70 L 145,85
          M 175,70 L 155,85
          M 95,78 L 175,78
        '
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='M 200,70 T 220,75 230,70 270,70'
        class='chord'
      />
    </g>
    <g class='table'>
      <path fill='none' stroke='#2D2D2D' stroke-width='1'
        d='M 0,50 L 35,50 M 65,50 100,50 M 200,50 L 240,50'
      />
    </g>
    <g class='cup'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 35,40 L 35,45 33,45 33,50
          C 33,52 68,52 68,50
          L 68,45 65,45 65,40
          C 65,38 35,38 35,40
          M 35,45
          C 35,47 68,47 68,45
          M 35,40
          C 35,42 65,42 65,40
        '
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 35,50 L 38,80
          Q 50,85 63,80
          L 65,50
          M 36,60 C 36,63 64,63 64,60
          M 37,75 C 37,80 63,80 63,75
        '
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LaptopSvg',
}
</script>

<style scoped>
@keyframes dim {
  0% {
    fill: #F2BF5C;
  }
  50% {
    fill: #F2BF5C;
  }
  100% {
    fill: #2D2D2D;
  }
}

.laptop {
  border: 2px solid #2D2D2D;
}

.animate .screen {
  animation: dim 5s ease;
}

.screen {
  transition: fill 200ms ease;
  fill: #2D2D2D;
}

.screen:hover {
  fill: #F2BF5C;
  transition: fill 200ms ease;
}
</style>
